import { useState } from "react";
// 4 more Gallery image
import Gallery5  from '@/assets/5.webp';
import Gallery6  from '@/assets/6.webp';
import Gallery7  from '@/assets/7.webp';
import Gallery8  from '@/assets/8.webp';
import Vid from '@/assets/cat_vid.mp4';

export default function GallerySection() {
  const [lightboxImage, setLightboxImage] = useState<string | null>(null);

  const images = [
    Vid,
    Gallery5,
    Gallery6,
    Gallery7,
    Gallery8,
  ];

  return (
    <section className="py-24 relative bg-background-muted">
      <div className="mx-auto container-custom px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="grid gap-2.5 pb-10 lg:pb-16 text-center">
          <h2 className="text-primary text-4xl font-bold font-manrope">
            Our Gallery
          </h2>
          <p className="text-primary-900 text-lg font-normal leading-8">
            Explore our collection of stunning visuals showcasing our work and
            creativity.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="gallery space-y-10">
          {/* Row 1 */}
          <div className="grid md:grid-cols-12 gap-8 mb-7 lg:mb-11">
            <div className="md:col-span-4 h-[277px] md:h-[404px] rounded-3xl overflow-hidden">
              {/* <img
                src={images[0]}
                alt="Gallery"
                className="gallery-image object-cover rounded-3xl w-full h-full transition-all duration-700 ease-in-out hover:grayscale cursor-pointer"
                onClick={() => setLightboxImage(images[0])}
              /> */}
         
              {/* show video */}
      
                  
                  <video
                    src={images[0]}
                    className="gallery-image object-cover rounded-3xl w-full h-full transition-all duration-700 ease-in-out hover:grayscale cursor-pointer"
                    autoPlay
                    loop
                    muted
                  ></video>


            </div>
            <div className="md:col-span-8 h-[277px] md:h-[404px] rounded-3xl overflow-hidden">
              <img
                src={images[1]}
                alt="Gallery"
                className="gallery-image object-cover rounded-3xl w-full h-full transition-all duration-700 ease-in-out hover:grayscale cursor-pointer"
                onClick={() => setLightboxImage(images[1])}
              />
            </div>
          </div>

          {/* Row 2 */}
          <div className="grid md:grid-cols-3 grid-cols-1 gap-8">
            {images.slice(2).map((src, i) => (
              <div key={i} className="h-[277px] w-full rounded-3xl overflow-hidden">
                <img
                  src={src}
                  alt="Gallery"
                  className="gallery-image object-cover rounded-3xl w-full h-full transition-all duration-700 ease-in-out hover:grayscale cursor-pointer"
                  onClick={() => setLightboxImage(src)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {lightboxImage && (
        <div
          className="fixed inset-0 z-[999] bg-black/80 flex items-center justify-center"
          onClick={(e) => {
            if (e.target === e.currentTarget) setLightboxImage(null);
          }}
        >
          <span
            className="absolute top-6 right-8 text-white text-4xl cursor-pointer hover:scale-110 transition-transform"
            onClick={() => setLightboxImage(null)}
          >
            &times;
          </span>
          <img
            src={lightboxImage}
            alt="Lightbox"
            className="max-w-full max-h-[90vh] rounded-lg shadow-2xl"
          />
        </div>
      )}
    </section>
  );
}
